export function handleArray (value) {
  return typeof value === 'object' ? value[0] : value
}

export function formatPrice (price) {
  if (price === undefined) return
  return price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
}

export function getStep (step, ml) {
  const steps = {
    1: ml.get('STEP_1'),
    2: ml.get('STEP_2'),
    3: ml.get('STEP_3'),
    4: ml.get('STEP_4'),
    5: ml.get('CONCLUDED')
  }
  return steps[step]
}

export function capitalize (value) {
  if (!value) return value
  return value.charAt(0).toLocaleUpperCase('tr-TR') + value.slice(1)
}

export function fullname (contact) {
  if (contact === null || contact === undefined) return ''
  const name = contact['n'] === undefined || contact['n'] === null ? '' : contact['n']
  const surname = contact['sn'] === undefined || contact['sn'] === null ? '' : contact['sn']
  return name + ' ' + surname
}

export function truncate (value, maxLength) {
  if (value === null || value === undefined) return
  return value.length > maxLength ? value.substring(0, maxLength) + '...' : value
}
